import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-web-design-and-development',
    templateUrl: './web-design-and-development.component.html',
    styleUrls: ['./web-design-and-development.component.scss'],
    standalone: false
})
export class WebDesignAndDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
